import React from "react";
import { useState } from "react";
import AboutHome from "../AboutHome/AboutHome";
import CallHomepage from "../CallHomepage/CallHomepage";
import Events from "../Events/Events";
import HeroCarousel from "../HeroCarousel/HeroCarousel";
import HeroSlider from "../HeroSlider/HeroSlider";
import Importance from "../Importance/Importance";
import News from "../News/News";
import Partners from "../Partners/Partners";
import ProcessCovered from "../ProcessCovered/ProcessCovered";
import Products from "../Products/Products";
import RupaliHealth from "../RupaliHealth/RupaliHealth";
import VisionHome from "../VisionHome/VisionHome";
import "./Home.scss";

const Home = () => {
  // code for modal

  // const [isModal, setIsModal] = useState(true);

  // const closeModal = () => {
  //   setIsModal(false);
  // };
  // const openModal = () => {
  //   setIsModal(true);
  // };

  // !code for modal

  return (
    <div className="home">
      {/* <HeroCarousel></HeroCarousel> */}
      <HeroSlider></HeroSlider>

      {/* code for modal */}

      {/* <Modal /> */}

      {/* <h3>Modal here</h3>
      <button onClick={openModal} type="button" className="btn btn-secondary">
        open
      </button>
      {isModal ? (
        <div className="react_modal">
          <div className="modal_content">
            <h5 className="modal-title">Modal title</h5>

            <div className="">
              <p>Modal body text goes here.</p>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary">
                Close
              </button>

              <button
                type="button"
                className="btn btn-primary"
                onClick={closeModal}
              >
                Save changes
              </button>
            </div>
          </div>
        </div>
      ) : (
        ""
      )} */}

      {/* !code for modal */}

      <AboutHome></AboutHome>
      <Products></Products>
      <RupaliHealth></RupaliHealth>
      <ProcessCovered></ProcessCovered>
      <Importance></Importance>

      <VisionHome></VisionHome>
      <Events></Events>
      {/* <News></News> */}
      <CallHomepage></CallHomepage>
      <Partners></Partners>
    </div>
  );
};

export default Home;
